/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type EntityPagesArticleModuleListQueryVariables = Types.Exact<{
  pageUrn: Types.Scalars['GlobalID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status?: Types.InputMaybe<Types.ContentArticleStatus>;
  requestMetadata?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  requestFeaturedArticle?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type EntityPagesArticleModuleListQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    contentPage?: {
      __typename?: 'ContentManagedPage';
      metadata?: {
        __typename?: 'ContentManagedPageMetadata';
        draftArticlesCount: number;
        scheduledArticlesCount: number;
        disabledArticlesCount: number;
        publishedArticlesCount: number;
      } | null;
    } | null;
  } | null;
  contentPageFeaturedArticle?: {
    __typename?: 'ContentPageArticle';
    isFeatured: boolean;
    status: Types.ContentArticleStatus;
    object:
      | {
          __typename: 'ArticlesArticle';
          id: string;
          globalId: string;
          content?: any | null;
          publishedAt?: string | null;
          updatedAt: string;
          visitUrl?: string | null;
          socialInteractionTargetUrn?: string | null;
          header: {
            __typename?: 'ArticleHeader';
            title: { __typename?: 'ArticleTitle'; text: string };
            summary?: { __typename?: 'ArticleSummary'; text: string } | null;
            cover?:
              | {
                  __typename: 'ArticleCoverImage';
                  url?: string | null;
                  caption?: {
                    __typename?: 'ArticleCaption';
                    text?: string | null;
                  } | null;
                }
              | {
                  __typename: 'ArticleCoverVideo';
                  caption?: {
                    __typename?: 'ArticleCaption';
                    text?: string | null;
                  } | null;
                  video?: {
                    __typename?: 'VideoV2';
                    defaultThumbnails?: Array<{
                      __typename?: 'VideoThumbnail';
                      sources?: Array<{
                        __typename?: 'VideoImageSource';
                        source: string;
                      }> | null;
                    }> | null;
                    customThumbnails?: Array<{
                      __typename?: 'VideoThumbnail';
                      sources?: Array<{
                        __typename?: 'VideoImageSource';
                        source: string;
                      }> | null;
                    }> | null;
                    sources?: Array<{
                      __typename?: 'VideoSource';
                      source: string;
                    }> | null;
                  } | null;
                }
              | null;
          };
          socialInteractionTarget?: {
            __typename?: 'SocialInteractionTarget';
            commentsCount: number;
            sharesCount: number;
            reactionsCount: number;
          } | null;
        }
      | {
          __typename: 'ContentArticle';
          id: string;
          globalId: string;
          title?: string | null;
          description?: string | null;
          socialInteractionTargetUrn?: string | null;
          hasVideo: boolean;
          publishedAt?: string | null;
          updatedAt: string;
          url: string;
          source: string;
          socialInteractionTarget?: {
            __typename?: 'SocialInteractionTarget';
            commentsCount: number;
            sharesCount: number;
            reactionsCount: number;
          } | null;
          image: {
            __typename?: 'ContentArticleImage';
            srcWide?: string | null;
            srcWide2x?: string | null;
          };
        };
    metadata: {
      __typename?: 'ContentArticleMetadata';
      readCount: number;
      clicksCount?: number | null;
    };
  } | null;
  contentPageArticles?: {
    __typename?: 'ContentPageArticlesConnection';
    total: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'ContentPageArticleEdge';
      cursor: string;
      node: {
        __typename?: 'ContentPageArticle';
        isFeatured: boolean;
        status: Types.ContentArticleStatus;
        object:
          | {
              __typename: 'ArticlesArticle';
              id: string;
              globalId: string;
              content?: any | null;
              publishedAt?: string | null;
              updatedAt: string;
              visitUrl?: string | null;
              socialInteractionTargetUrn?: string | null;
              header: {
                __typename?: 'ArticleHeader';
                title: { __typename?: 'ArticleTitle'; text: string };
                summary?: {
                  __typename?: 'ArticleSummary';
                  text: string;
                } | null;
                cover?:
                  | {
                      __typename: 'ArticleCoverImage';
                      url?: string | null;
                      caption?: {
                        __typename?: 'ArticleCaption';
                        text?: string | null;
                      } | null;
                    }
                  | {
                      __typename: 'ArticleCoverVideo';
                      caption?: {
                        __typename?: 'ArticleCaption';
                        text?: string | null;
                      } | null;
                      video?: {
                        __typename?: 'VideoV2';
                        defaultThumbnails?: Array<{
                          __typename?: 'VideoThumbnail';
                          sources?: Array<{
                            __typename?: 'VideoImageSource';
                            source: string;
                          }> | null;
                        }> | null;
                        customThumbnails?: Array<{
                          __typename?: 'VideoThumbnail';
                          sources?: Array<{
                            __typename?: 'VideoImageSource';
                            source: string;
                          }> | null;
                        }> | null;
                        sources?: Array<{
                          __typename?: 'VideoSource';
                          source: string;
                        }> | null;
                      } | null;
                    }
                  | null;
              };
              socialInteractionTarget?: {
                __typename?: 'SocialInteractionTarget';
                commentsCount: number;
                sharesCount: number;
                reactionsCount: number;
              } | null;
            }
          | {
              __typename: 'ContentArticle';
              id: string;
              globalId: string;
              title?: string | null;
              description?: string | null;
              socialInteractionTargetUrn?: string | null;
              hasVideo: boolean;
              publishedAt?: string | null;
              updatedAt: string;
              url: string;
              source: string;
              socialInteractionTarget?: {
                __typename?: 'SocialInteractionTarget';
                commentsCount: number;
                sharesCount: number;
                reactionsCount: number;
              } | null;
              image: {
                __typename?: 'ContentArticleImage';
                srcWide?: string | null;
                srcWide2x?: string | null;
              };
            };
        metadata: {
          __typename?: 'ContentArticleMetadata';
          readCount: number;
          clicksCount?: number | null;
        };
      };
    } | null>;
  } | null;
};

export const EntityPagesArticleModuleListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityPagesArticleModuleList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageUrn' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GlobalID' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'before' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContentArticleStatus' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestMetadata' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestFeaturedArticle' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'requestMetadata' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentPage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'pageGlobalId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pageUrn' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'draftArticlesCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'scheduledArticlesCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'disabledArticlesCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'publishedArticlesCount',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPageFeaturedArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageUrn' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageUrn' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'requestFeaturedArticle' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ArticlesModuleCardNode' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPageArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageUrn' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageUrn' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'last' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'before' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ArticlesModuleCardNode',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SocialInteractionTargetCount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SocialInteractionTarget' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'commentsCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sharesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reactionsCount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticlesModuleCardContentArticle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialInteractionTargetUrn' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialInteractionTarget' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SocialInteractionTargetCount' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'srcWide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'srcWide2x' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVideo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticlesModuleCardArticlesArticle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cover' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleCoverImage' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caption' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleCoverVideo' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caption' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'video' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'defaultThumbnails',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sources',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'source',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'customThumbnails',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sources',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'source',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sources' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'source',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visitUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialInteractionTargetUrn' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialInteractionTarget' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SocialInteractionTargetCount' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticlesModuleCardNode' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentPageArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'object' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ContentArticle' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ArticlesModuleCardContentArticle',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ArticlesArticle' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ArticlesModuleCardArticlesArticle',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'readCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clicksCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPagesArticleModuleListQuery,
  EntityPagesArticleModuleListQueryVariables
>;
